import { render } from "./Passings.vue?vue&type=template&id=260b935b&scoped=true"
import script from "./Passings.vue?vue&type=script&lang=js"
export * from "./Passings.vue?vue&type=script&lang=js"

import "./Passings.vue?vue&type=style&index=0&id=260b935b&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260b935b"]])

export default __exports__